import React, { useEffect, useState } from "react";
import Footer from "../Header/Footer";
import Header from "../Header/Header";
import Config from "../Header/Config";
import { FaEdit, FaTrashAlt, FaFileExcel, FaFilePdf } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { exportFilteredToExcel } from "../../utils/excelExport";
import { exportFilteredToPDF } from "../../utils/pdfExport";
const ITEMS_PER_PAGE = 500; // Number of items to display per page

export default function Model_table() {
  const apiUrl = Config.apiUrl;
  const [isLoading, setIsLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchTableData = async () => {
      try {
        if (tableData.length === 0) {
          const response = await fetch(`${apiUrl}/get_all_models`);
          const data = await response.json();
          console.log("get_all_models response:", data);
          const items = Array.isArray(data.data) ? data.data.slice().reverse() : [];
          setTableData(items);
          setIsLoading(false);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    // Only fetch data if tableData is empty
    if (tableData.length === 0) {
      fetchTableData();
    }
  }, [apiUrl, tableData.length]);

  const handleDelete = (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this record?"
    );

    if (confirmDelete) {
      fetch(`${apiUrl}/delete_model/${id}`, {
        method: "DELETE",
      })
        .then((response) => response.json())
        .then(() => {
          toast.success("Record deleted successfully", { autoClose: 1500 });
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error deleting data:", error);
        });
    }
  };

  const handleUpdate = (id, event) => {
    navigate(`/model_update?id=${id}`);
  };
  //.....................................[ Search box ]...............................................
  const [searchQuery, setSearchQuery] = useState(""); // State variable for the search query
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };
  const filteredTableData = tableData.filter(
    (row) =>
      (row.model_name &&
        row.model_name.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (row.color_name &&
        row.color_name.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  //..................................[ Pagination ].........................................

  const [currentPage, setCurrentPage] = useState(1);

  // Calculate the total number of pages based on the data and items per page
  const totalPages = Math.ceil(filteredTableData.length / ITEMS_PER_PAGE);

  // Calculate the index range for the items to be displayed on the current page
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = Math.min(
    startIndex + ITEMS_PER_PAGE,
    filteredTableData.length
  );

  // Function to handle pagination button clicks
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // Excel Export Handler
  const handleExportToExcel = () => {
    const columns = [
      { key: 'model_name', label: 'Model' },
      { key: 'color_name', label: 'Color' },
      { key: 'description', label: 'Description' },
      { key: 'status', label: 'Status' },
    ];
    exportFilteredToExcel(filteredTableData, columns, 'ModelList');
  };

  // PDF Export Handler
  const handleExportToPDF = () => {
    const columns = [
      { key: 'model_name', label: 'Model' },
      { key: 'color_name', label: 'Color' },
      { key: 'description', label: 'Description' },
      { key: 'status', label: 'Status' },
    ];
    exportFilteredToPDF(filteredTableData, columns, 'ModelList');
  };

  return (
    <>
      <ToastContainer />
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <h4 className="fw-bold py-3 mb-4">Model List</h4>

                <hr className="my-3" />
                {/* Search Box and Export Button */}
                <div style={{ display: "flex", justifyContent: "end", gap: "10px", alignItems: "center" }}>
                  <div className="mb-3 col-md-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={handleSearch}
                    />
                  </div>
                  {/* <div className="mb-3">
                    <button
                      className="btn btn-success"
                      onClick={handleExportToExcel}
                      disabled={!filteredTableData || filteredTableData.length === 0}
                      title="Export to Excel"
                      style={{ display: "flex", alignItems: "center", gap: "5px" }}
                    >
                      <FaFileExcel />
                      Export Excel
                    </button>
                  </div> */}
                  <div className="mb-3">
                    <button
                      className="btn btn-danger"
                      onClick={handleExportToPDF}
                      disabled={!filteredTableData || filteredTableData.length === 0}
                      title="Export to PDF"
                      style={{ display: "flex", alignItems: "center", gap: "5px" }}
                    >
                      <FaFilePdf />
                      Export PDF
                    </button>
                  </div>
                </div>

                <div className="card">
                  <h5 className="card-header">Model List</h5>
                  <div
                    className="table-responsive text-nowrap"
                    style={{ overflowY: "auto", maxHeight: "600px" }}
                  >
                    {isLoading ? (
                      //spinner
                      <div className="d-flex justify-content-center mb-5">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="sr-only "></span>
                        </div>
                      </div>
                    ) : (
                      <table className="table mb-3">
                        <thead
                          style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 1,
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          <tr className="text-nowrap">
                            <th>SN</th>
                            <th>Model</th>
                            <th>Color</th>

                            <th>Description</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(filteredTableData) &&
                            filteredTableData.length > 0 ? (
                            filteredTableData
                              .slice(startIndex, endIndex)
                              .map((row, index) => {
                                const originalIndex = tableData.findIndex(item => item.id === row.id);
                                return (
                                <tr key={index}>
                                  <td>{originalIndex !== -1 ? originalIndex + 1 : startIndex + index + 1}</td>
                                  <td>{row.model_name}</td>
                                  <td>{row.color_name}</td>

                                  <td>{row.description}</td>
                                  <td>
                                    <button style={{
                                      padding: "0px",
                                      marginLeft: "2px",
                                      marginRight: "2px",
                                      backgroundColor: "transparent", // Set background color to transparent
                                      color: "white", // Set text color to white
                                      border: "1px solid #fff", // Add a border for better visibility
                                    }}
                                      type="button"
                                      className="btn"
                                      onClick={() => handleUpdate(row.id)}
                                    >
                                      <FaEdit style={{ color: "blue" }} />
                                    </button>
                                    <span className="ml-2"> </span>
                                    <button style={{
                                      padding: "0px",
                                      marginLeft: "2px",
                                      marginRight: "2px",
                                      backgroundColor: "transparent", // Set background color to transparent
                                      color: "white", // Set text color to white
                                      border: "1px solid #fff", // Add a border for better visibility
                                    }}
                                      type="button"
                                      className="btn "
                                      onClick={() => handleDelete(row.id)}
                                    >
                                    <FaTrashAlt style={{ color: "red" }} />
                                  </button>
                                </td>
                              </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={6}>No data available</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
                {/* Pagination */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "10px 10px",
                  }}
                >
                  <nav aria-label="Page navigation">
                    <ul className="pagination">
                      {/* Previous arrow button */}
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          {"<"}
                        </button>
                      </li>

                      {/* Page numbers */}
                      {Array.from(
                        { length: totalPages },
                        (_, index) => index + 1
                      ).map(
                        (pageNumber) =>
                          // Render the page number button only if it's within the range of visible pages
                          pageNumber >= currentPage - 2 &&
                          pageNumber <= currentPage + 2 && (
                            <li
                              key={pageNumber}
                              className={`page-item ${pageNumber === currentPage ? "active" : ""
                                }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => handlePageChange(pageNumber)}
                              >
                                {pageNumber}
                              </button>
                            </li>
                          )
                      )}

                      {/* Next arrow button */}
                      <li
                        className={`page-item ${currentPage === totalPages ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          {">"}
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>

              <Footer />

              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle" />
      </div>
    </>
  );
}
